import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);
  const [categories, setCategories] = useState([]);
  const [dataExcel, setDataExcel] = useState(undefined);
  const [dataImport, setDataImport] = useState({});

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listCategory() {
    const cat =['013','011','040','012'];
    let response = await wsFindBy('logi/category-multiple', { code: cat, base_business_partner_id: 17 });
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging([]);
      listZones();
      listCategory();
    }
    setDataExcel(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (zones.length > 0 && cuota.codsede) {
      handleChange("codsede", String(cuota.codsede));
    }
  },[zones]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setDataExcel({
        success: dataImport.success,
        rebate: dataImport.data.map((item) => {
          return {
            base_zone_code: item.SEDE,
            logi_category_code: item.CATEGORIA,
            tipo: item.TIPO,
            cuota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setDataExcel(undefined);
    }
  }, [dataImport]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de Rebate para Winter`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataExcel?.success
            ? 'sale/cuota-rebate/multiple'
            : 'sale/cuota-rebate'
        }
        dataForce={
          dataExcel?.success
            ? {
                rebate: dataExcel?.rebate,
              }
            : {
                base_zone_id: dataChanging.base_zone_id,
                logi_category_id: dataChanging.logi_category_id,
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Sede" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_zone_id', item?.id);handleChange('codsede', item?.code);setDataImport(null);}}
            value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null }
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['SEDE','CATEGORIA','TIPO']}
            sortDuplicate={['SEDE','CATEGORIA','TIPO']}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota de rebate`,
              fields: ['SEDE','CATEGORIA','TIPO','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {!dataImport?.success ? (
          <>
            <Autocomplete
              disableClearable
              options={categories}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Categoría" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('logi_category_id', item?.id);}}
              value={categories.find((cat) => String(cat.id) === String(dataChanging.logi_category_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                defaultValue={!!cuota ? cuota.tipo : ''}
                inputProps={{
                  name: 'tipo',
                }}
              >
                <MenuItem value="I">Compra</MenuItem>
                <MenuItem value="O">Venta</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Cuota"
              fullWidth
              type="number"
              name="cuota"
              margin="normal"
              defaultValue={!!cuota ? cuota.cuota : ''}
              onChange={(e) => handleChange('cuota', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});

